import packageInfo from '../../../../package.json';

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyD1nJ5By2gbXAIei9xwkfNH3VOWl8Y5dU4",
    authDomain: "ecoacsa-develop.firebaseapp.com",
    projectId: "ecoacsa-develop",
    storageBucket: "ecoacsa-develop.appspot.com",
    messagingSenderId: "374065550274",
    appId: "1:374065550274:web:4e4df0122fbe76ac30bc5b",
    region: 'europe-west1',
  },
  version: packageInfo.version,     
};
